import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadRoutingRuleEpic } from './_epics/loadRoutingRule.epic';
import { updateRoutingRuleEpic } from './_epics/updateRoutingRule.epic';
import { validateRoutingRuleEpic } from './_epics/validateRoutingRule.epic';
import { exportRoutingRulesEpic } from './_epics/exportRoutingRules.epic';
import { reloadRoutingRuleListEpic } from './_epics/reloadRoutingRule.epic';

export const routingRuleEpic = safeCombineEpics(
  loadRoutingRuleEpic,
  updateRoutingRuleEpic,
  validateRoutingRuleEpic,
  exportRoutingRulesEpic,
  reloadRoutingRuleListEpic,
);
